const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const DIGITS = '0123456789';
const SPECIAL_CHARS = '@$!%*#?&{}/()|';
const FULL_ALPHABET = `${LOWERCASE}${UPPERCASE}${DIGITS}${SPECIAL_CHARS}`;

/** Same pattern as backend `password_is_validate` in utils/auth/passwords.py */
export const PASSWORD_REGEX =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&{}/()|])[\w\d@$!%*#?&{}/()|]{6,}$/;

export const PASSWORD_MIN_LENGTH = 6;

export const PASSWORD_VALIDATION_MESSAGE =
  'Пароль должен быть не менее 6 символов, состоять из буквы латинского алфавита в верхнем ' +
  'и нижнем регистре, цифр и спецсимволов (@$!%*#?&{}/()|)';

export function isPasswordValid(password: string): boolean {
  return PASSWORD_REGEX.test(password);
}

function pickRandomChar(alphabet: string): string {
  const index = crypto.getRandomValues(new Uint32Array(1))[0] % alphabet.length;
  return alphabet[index];
}

/** Port of backend `random_password()` — guaranteed to pass PASSWORD_REGEX */
export function generateSecurePassword(length: number = 12): string {
  if (length < 4) {
    throw new Error('Password length must be at least 4');
  }

  const passwordChars = [
    pickRandomChar(LOWERCASE),
    pickRandomChar(UPPERCASE),
    pickRandomChar(DIGITS),
    pickRandomChar(SPECIAL_CHARS),
  ];

  for (let index = passwordChars.length; index < length; index += 1) {
    passwordChars.push(pickRandomChar(FULL_ALPHABET));
  }

  for (let index = passwordChars.length - 1; index > 0; index -= 1) {
    const swapIndex = crypto.getRandomValues(new Uint32Array(1))[0] % (index + 1);
    const temp = passwordChars[index];
    passwordChars[index] = passwordChars[swapIndex];
    passwordChars[swapIndex] = temp;
  }

  return passwordChars.join('');
}
